import RestApi from '~services/restApi'
import _ from 'lodash'

import {
  createDocumentMutation,
  createLandDocumentMutation,
  getDocumentSignaturesByDocumentIdQuery,
  createResidentDocumentMutation,
  deleteDocumentMutation,
  updateDocumentMutation,
  updateDocumentAndCleanAIMutation,
  approveDocumentMutation,
  reproveDocumentMutation,
  getDocumentsQuery,
  getDocumentByIdQuery,
  getAllDocumentsTypesQuery,
  getDocumentsByLandIdQuery,
  getAllDocumentsByLandIdQuery,
  getAllDocumentsByLandIdsQuery,
  getAllDocumentsByContractIdQuery,
  getAllDocumentsQuery,
  getDocumentsByResidentIdQuery,
  createDocumentTypeMutation,
  updateDocumentTypeMutation,
  deleteDocumentTypeMutation,
  updateDocumentNoReturnMutation
} from '~graphql/documents.graphql'

import {
  getAllDocumentsContextsQuery,
  getAllDocumentsVariablesQuery,
  createDocumentVariableMutation,
  updateDocumentVariableMutation,
  deleteDocumentVariableMutation
} from '~graphql/documentVariables.graphql'

export default {
  // Documents
  getAllDocumentTypes({ dispatch, state }) {
    return dispatch('getItems', {
      state,
      modelName: 'documentTypes',
      loader: 'documentTypes:get',
      query: getAllDocumentsTypesQuery,
      resultPath: 'documentTypes.nodes'
    })
  },
  getDocuments({ state, dispatch }, { filter, offset, first, orderBy }) {
    const defaultFilter = {
      id: {
        isNull: false
      } // used to allow empty filter
    }
    const mergedFilter = _.merge(filter, defaultFilter)

    return dispatch('getItems', {
      state,
      loader: 'documents:get',
      query: getDocumentsQuery,
      resultPath: 'documents.nodes',
      totalPath: 'documents.totalCount',
      totalModelName: 'documentsTotalCount',
      variables: {
        filter: mergedFilter,
        offset,
        first,
        orderBy
      }
    })
  },
  getDocumentById({ state, dispatch }, id) {
    return dispatch('getItemById', {
      id,
      state,
      loader: 'document:get',
      query: getDocumentByIdQuery,
      resultPath: 'document',
      useCache: false
    })
  },
  getDocumentsByLandId({ dispatch, state }, landId) {
    return dispatch('getItems', {
      state,
      modelName: 'landDocuments',
      loader: 'landDocuments:get',
      query: getDocumentsByLandIdQuery,
      variables: { landId },
      resultPath: 'documents.nodes',
      useCache: false
    })
  },
  getAllDocumentsByLandId({ dispatch, state, commit }, landId) {
    commit('SET_ITEM', {
      state,
      item: [],
      modelName: 'allDocuments'
    })

    return dispatch('getItems', {
      state,
      modelName: 'allDocuments',
      loader: 'allDocuments:get',
      query: getAllDocumentsByLandIdQuery,
      variables: { landId },
      resultPath: 'documents.nodes',
      useCache: false
    })
  },
  getAllDocumentsByLandIds({ dispatch, state, commit }, landIds) {
    commit('SET_ITEM', {
      state,
      item: [],
      modelName: 'allDocuments'
    })

    return dispatch('getItems', {
      state,
      modelName: 'allDocuments',
      loader: 'allDocuments:get',
      query: getAllDocumentsByLandIdsQuery,
      variables: { landIds },
      resultPath: 'documents.nodes',
      useCache: false
    })
  },
  getAllDocuments({ dispatch, state }, filter) {
    return dispatch('getItems', {
      state,
      modelName: 'allDocuments',
      loader: 'allDocuments:get',
      query: getAllDocumentsQuery,
      variables: { filter },
      resultPath: 'documents.nodes',
      useCache: false
    })
  },
  getAllDocumentsByContractId({ dispatch, state, commit }, { contractId, landId, partnerIds }) {
    commit('SET_ITEM', {
      state,
      item: [],
      modelName: 'allDocuments'
    })

    return dispatch('getItems', {
      state,
      modelName: 'allDocuments',
      loader: 'allDocuments:get',
      query: getAllDocumentsByContractIdQuery,
      variables: { contractId, landId, partnerIds },
      resultPath: 'documents.nodes',
      useCache: false
    })
  },

  getDocumentsByResidentId({ dispatch, state }, residentId) {
    return dispatch('getItems', {
      state,
      modelName: 'residentDocuments',
      loader: 'residentDocuments:get',
      query: getDocumentsByResidentIdQuery,
      variables: { residentId },
      resultPath: 'documents.nodes',
      useCache: false
    })
  },
  getDocumentSignaturesByDocumentId({ dispatch, state }, documentId) {
    return dispatch('getItems', {
      state,
      modelName: 'documentSignatures',
      loader: 'documentSignatures:get',
      query: getDocumentSignaturesByDocumentIdQuery,
      variables: { documentId },
      resultPath: 'documentSignatures.nodes',
      useCache: false
    })
  },
  approveDocument({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      loader: 'approveDocument:update',
      mutation: approveDocumentMutation,
      resultPath: 'updateDocument.document'
    })
  },
  reproveDocument({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      loader: 'reproveDocument:update',
      mutation: reproveDocumentMutation,
      resultPath: 'updateDocument.document'
    })
  },
  updateDocument({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      loader: 'document:update',
      mutation: updateDocumentMutation,
      resultPath: 'updateDocument.document'
    })
  },
  updateDocumentNoReturn({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      loader: 'document:update',
      mutation: updateDocumentNoReturnMutation,
      resultPath: 'updateDocument.document'
    })
  },
  updateDocumentAndCleanAi({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      loader: 'document:update',
      mutation: updateDocumentAndCleanAIMutation,
      resultPath: 'updateDocument.document'
    })
  },
  deleteDocument({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      removeFrom: ['landDocuments', 'residentDocuments'],
      loader: 'document:delete',
      mutation: deleteDocumentMutation,
      resultPath: 'updateDocument.document'
    })
  },
  createDocument({ state, dispatch }, document) {
    return dispatch('createItem', {
      item: { document },
      state,
      loader: 'document:create',
      mutation: createDocumentMutation,
      resultPath: 'createDocument.document'
    })
  },
  createLandDocument({ state, dispatch }, document) {
    return dispatch('createItem', {
      item: document,
      state,
      addTo: ['landDocuments'],
      loader: 'landDocument:create',
      mutation: createLandDocumentMutation,
      resultPath: 'createDocument.document'
    })
  },
  createResidentDocument({ state, dispatch }, document) {
    return dispatch('createItem', {
      item: document,
      state,
      addTo: ['residentDocuments'],
      loader: 'residentDocument:create',
      mutation: createResidentDocumentMutation,
      resultPath: 'createDocument.document'
    })
  },
  aiExtractData(a, { documentId }) {
    return RestApi.aiExtractData(documentId).then(result => {
      return result.data
    })
  },
  aiValidateDocument(a, { documentId }) {
    return RestApi.aiValidateDocument(documentId).then(result => {
      const res = result.data

      // const landDocument = state.landDocuments.find((doc) => doc.id === documentId)
      // const residentDocument = state.residentDocuments.find((doc) => doc.id === documentId)
      // const allDocument = state.allDocuments.find((doc) => doc.id === documentId)

      // const document = _.cloneDeep(landDocument || residentDocument || allDocument)

      // if (document) {
      //   document.aiValidationIsValid = res.isValid
      //   document.aiValidationResult = res.results
      //   document.aiValidationExecutedAt = new Date().toISOString()
      //   if (landDocument) {
      //     commit('PERSIST_ITEM', {
      //       state: state,
      //       item: document,
      //       addTo: ['landDocuments']
      //     })
      //   }
      //   if (residentDocument) {
      //     commit('PERSIST_ITEM', {
      //       state: state,
      //       item: document,
      //       addTo: ['residentDocuments']
      //     })
      //   }
      //   if (allDocument) {
      //     commit('PERSIST_ITEM', {
      //       state: state,
      //       item: document,
      //       addTo: ['allDocuments']
      //     })
      //   }
      // }

      return res
    })
  },
  clearLandDocuments({ state, commit }) {
    commit('SET_ITEM', {
      state,
      item: [],
      modelName: 'landDocuments'
    })
  },
  clearResidentDocuments({ state, commit }) {
    commit('SET_ITEM', {
      state,
      item: [],
      modelName: 'residentDocuments'
    })
  },
  createDocumentType({ state, dispatch }, documentType) {
    return dispatch('createItem', {
      item: { documentType },
      state,
      addTo: ['documentTypes'],
      loader: 'documentType:persist',
      mutation: createDocumentTypeMutation,
      resultPath: 'createDocumentType.documentType'
    })
  },
  updateDocumentType({ state, dispatch }, documentType) {
    return dispatch('createItem', {
      item: documentType,
      state,
      addTo: ['documentTypes'],
      loader: 'documentType:persist',
      mutation: updateDocumentTypeMutation,
      resultPath: 'updateDocumentType.documentType'
    })
  },
  deleteDocumentType({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      removeFrom: ['documentTypes'],
      loader: 'documentType:delete',
      mutation: deleteDocumentTypeMutation
    })
  },

  /* Document Variables */

  getAllDocumentContexts({ dispatch, state }) {
    return dispatch('getItems', {
      state,
      modelName: 'documentContexts',
      loader: 'documentContexts:get',
      query: getAllDocumentsContextsQuery,
      resultPath: 'documentContexts.nodes'
    })
  },

  getAllDocumentVariables({ dispatch, state }) {
    return dispatch('getItems', {
      state,
      modelName: 'documentVariables',
      loader: 'documentVariables:get',
      query: getAllDocumentsVariablesQuery,
      resultPath: 'documentVariables.nodes'
    })
  },
  createDocumentVariable({ state, dispatch }, documentVariable) {
    return dispatch('createItem', {
      item: { documentVariable },
      state,
      addTo: ['documentVariables'],
      loader: 'documentVariable:persist',
      mutation: createDocumentVariableMutation,
      resultPath: 'createDocumentVariable.documentVariable'
    })
  },
  updateDocumentVariable({ state, dispatch }, documentVariable) {
    return dispatch('createItem', {
      item: documentVariable,
      state,
      addTo: ['documentVariables'],
      loader: 'documentVariable:persist',
      mutation: updateDocumentVariableMutation,
      resultPath: 'updateDocumentVariable.documentVariable'
    })
  },
  deleteDocumentVariable({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      removeFrom: ['documentVariables'],
      loader: 'documentVariable:delete',
      mutation: deleteDocumentVariableMutation
    })
  }
}
